export default {"src":"/_next/static/media/step_background_3.64467909.svg","height":134,"width":134,"blurWidth":0,"blurHeight":0};